import { useEffect, useRef, useCallback } from "react";
import api from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useSSE(onEvent) {
  const eventSourceRef = useRef(null);
  const onEventRef = useRef(onEvent);
  const retryDelayRef = useRef(5000);
  onEventRef.current = onEvent;

  const connect = useCallback(async () => {
    if (eventSourceRef.current) return;
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      // Get dedicated SSE token (short-lived, single-purpose)
      const res = await api.post("/sse/token");
      const sseToken = res.data.sse_token;

      const url = `${BACKEND_URL}/api/sse/events?token=${sseToken}`;
      const es = new EventSource(url);
      eventSourceRef.current = es;

      es.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          if (msg.event && msg.event !== "connected") {
            onEventRef.current?.(msg.event, msg.data);
          }
          retryDelayRef.current = 5000;
        } catch { /* ignore */ }
      };

      es.onerror = () => {
        es.close();
        eventSourceRef.current = null;
        const delay = retryDelayRef.current;
        retryDelayRef.current = Math.min(delay * 1.5, 60000);
        setTimeout(connect, delay);
      };
    } catch {
      const delay = retryDelayRef.current;
      retryDelayRef.current = Math.min(delay * 1.5, 60000);
      setTimeout(connect, delay);
    }
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, [connect]);
}
